import React from 'react'

export const GeneralModal = (props) => {
    const { title, body, footer } = props
    return (
        <div>
            <div className="modal fade " id="generalModal" data-backdrop="static" data-keyboard="false" >
                <div className="modal-dialog modal-xl" >
                    <div className="modal-content">
                        <div className="modal-header" style={{ background: "#343a40" }}> {title} </div>
                        <div className="modal-body"> {body} </div>
                        <div className="modal-footer"> {footer} </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default GeneralModal